import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " file_download ", -1)
const _hoisted_2 = { class: "text-darkText" }
const _hoisted_3 = { class: "mb-4 text-muted" }
const _hoisted_4 = { class: "flex items-center mb-2 space-x-2" }
const _hoisted_5 = { class: "text-sm text-muted" }
const _hoisted_6 = { class: "flex items-center mt-12 ml-1.5 space-x-2 w-44 hidden" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_CheckboxGroup = _resolveComponent("CheckboxGroup")!
  const _component_SegmentedControls = _resolveComponent("SegmentedControls")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Btn, {
      tooltip: _ctx.$t('misc.download_results'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = true)),
      outline: true,
      variant: 'icon',
      disabled: (_ctx.mainStore.eventParticipations?.length ?? 0) === 0
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["tooltip", "disabled"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showDialog,
      yesText: _ctx.loadingReport ? _ctx.$t('misc.downloading') : _ctx.$t('misc.download'),
      noText: _ctx.$t('dialog.default_cancel_text'),
      disableOk: _ctx.loadingReport,
      onNo: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog = false)),
      onYes: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDownload())),
      fullWidth: true
    }, {
      title: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("participation_downloader.download_results")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("participation_downloader.introduction")), 1),
          _createVNode(_component_RadioGroup, {
            modelValue: _ctx.selectedDownloadPreset,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDownloadPreset) = $event)),
            options: _ctx.presetsAsOptions
          }, {
            item: _withCtx(({ description }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(description), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"]),
          _createElementVNode("div", {
            class: _normalizeClass([{
							'opacity-40': _ctx.selectedDownloadPreset !== _ctx.ReportSettingsPreset.CUSTOM,
						}, "mb-12 ml-7"])
          }, [
            _createVNode(_component_CheckboxGroup, {
              disabled: _ctx.selectedDownloadPreset !== _ctx.ReportSettingsPreset.CUSTOM,
              options: _ctx.fieldsAsOptions,
              class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-2",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (
								_ctx.downloadSettingsProxy = {
									..._ctx.downloadSettingsProxy,
									fields: $event,
								}
							)),
              modelValue: _ctx.availablePresets[_ctx.ReportSettingsPreset.CUSTOM].fields
            }, null, 8, ["disabled", "options", "modelValue"])
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SegmentedControls, {
              class: "w-full",
              options: _ctx.formatsAsOptions,
              modelValue: _ctx.reportType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reportType) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("participation_downloader.report_type")), 1)
              ]),
              _: 1
            }, 8, ["options", "modelValue"])
          ]),
          (_ctx.downloadSettings)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText", "disableOk"])
  ]))
}